import React from 'react';
interface Vendor {
  vendorName: string;
  complaints: number;
  solved: number;
  pending: number;
}

interface EfficiencyTableProps {
  vendors: Vendor[];
}

const EfficiencyTable = ({ vendors }: EfficiencyTableProps) => {
  return (
    <div style={{ height: '347px', overflowY: 'auto' }}>
      <table className="w-full">
        <thead>
          <tr className="md:text-sm text-xs font-normal  sticky top-0">
            <th className="text-left">Vendors</th>
            <th>Complaints</th>
            <th>Pending</th>
            <th>Solved</th>
          </tr>
        </thead>
        <tbody>
          {vendors?.map((vendor: Vendor, index: number) => (
            <tr key={index}>
              <td className="pt-5">
                <div className="flex items-center gap-1 xl:gap-3 ">
                  <div className="justify-start">
                    <div className="w-6 h-6 md:w-10 md:h-10 bg-[#D9D9D9] rounded-full cursor-pointer items-center flex justify-center text-black font-regular text-xs md:text-sm font-bold">
                      {vendor.vendorName[0]?.toUpperCase() || 'A'}
                    </div>
                  </div>
                  <div>
                    <label className=" text-xs md:text-sm font-normal text-white">
                      {vendor.vendorName}
                    </label>
                  </div>
                </div>
              </td>
              <td className="text-xs md:text-sm font-normal text-white text-center pt-5">
                {vendor.complaints}
              </td>
              <td className="text-xs md:text-sm font-normal text-white text-center pt-5">
                {vendor.pending}
              </td>
              <td className="text-xs md:text-sm font-normal text-white text-center pt-5">
                {vendor.solved}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EfficiencyTable;
